import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import c from "./batchTransmit.ce.vue.js";
import { vCopyVueucStylesToShadowDom as u } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as d } from "../../utils/vShadowPropertyPolyfill.js";
import { defineComponent as h, useTemplateRef as v, computed as _, withDirectives as C, openBlock as y, createBlock as g, withCtx as m, createVNode as l } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as P } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { ref as w, unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import T from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import { NDialogProvider as x } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/DialogProvider.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const q = /* @__PURE__ */ h({
  name: "BatchTransmitEntry",
  __name: "index.ce",
  setup(b, { expose: p }) {
    const o = P(), i = v("batchTransmitRef"), n = {
      orange: "#FC9153",
      blue: "#2980ff"
    }, r = w(n.orange), f = _(() => ({
      common: {
        primaryColor: r.value,
        primaryColorHover: r.value,
        primaryColorPressed: r.value,
        primaryColorSuppl: r.value
      }
    }));
    return p({ open: (t) => {
      var a, s;
      return r.value = n[(a = t.theme) != null ? a : "orange"], ((s = i.value) == null ? void 0 : s.open(t)) || Promise.resolve(!1);
    } }), (t, a) => C((y(), g(e(T), {
      locale: e(N),
      "date-locale": e(R),
      "theme-overrides": f.value,
      "style-mount-target": e(o)
    }, {
      default: m(() => [
        l(e(S), { to: e(o) }, {
          default: m(() => [
            l(e(x), { to: e(o) }, {
              default: m(() => [
                l(c, {
                  ref_key: "batchTransmitRef",
                  ref: i
                }, null, 512)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "theme-overrides", "style-mount-target"])), [
      [e(u), e(o)],
      [e(d), e(o)]
    ]);
  }
});
export {
  q as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/batch-transmit/index.ce.vue2.js
// module id = 1221
// module chunks = 67